// dependencies
import { useEffect, useState } from "react";


// style
import styles from "./css/Modal.module.css"


export default function SimpleModal({ children, show, onClose }) {
    const [isVisible, setIsVisible] = useState(show);
    const [animationClass, setAnimationClass] = useState("");

    useEffect(() => {
        if (show) {
            setIsVisible(true);
            // triger animation slide in
            setAnimationClass(styles.enter);
        } else {
            setAnimationClass(styles.exit);
            // delay unmount until after slide out animation
            setTimeout(() => setIsVisible(false), 500);
        }
    }, [show]);

    const handleClickOutside = (e) => {
        if (e.target.classList.contains(styles.overlay)) {
            onClose?.();
        }
    };

    if (!isVisible) return null;

    return (
        <div className={styles.overlay} onClick={handleClickOutside}>
            <div className={`${styles.modal} ${animationClass}`}>
                <div className={styles.modalContent}>{children}</div>
            </div>
        </div>
    );
}
